import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RateReviewIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rate_review"}/>
}
